import {FC} from 'react';
import {Suspense} from 'react';
import {Provider} from 'react-redux';
import {BrowserRouter} from 'react-router-dom';
import App from './components/App';
import store from './redux/store';
import useArticlesLoaded from "./hooks/useArticlesLoaded";
import useScrollToTop from './hooks/useScrollToTop';
import './helpers/axios';

const ScrollToTop: FC = () => {
  useScrollToTop();
  return null;
}

const ArticlesLoaded: FC = () => {
  useArticlesLoaded();
  return null;
}

const Root: FC = () => (
  <Suspense fallback={null}>
    <BrowserRouter>
      <ScrollToTop />

      <Provider store={store}>
        <ArticlesLoaded />

        <App />
      </Provider>
    </BrowserRouter>
  </Suspense>
);

export default Root;
